import axios, { AxiosResponse } from 'axios';
import {
  ProductAccountTypes,
  ProductAddonsReq,
  ProductData,
  ProductMarketDataReq,
  ProductOffer,
  ProductOption,
  ProductResetReq,
  ProductTypes,
  TPackages,
} from '@src/types';
import qs from 'qs';
import { ProductFile } from '@src/types/file.ts';

export type ProductQueries = {
  categories?: ProductTypes | ProductTypes[];
  account_types?: ProductAccountTypes | ProductAccountTypes[];
  is_bundle?: boolean;
  datafeed?: string;
  account_status?: 'active' | 'inactive';
};

export type AddonsAssociationsReq = {
  addon_ids?: number[];
  account_ids?: number[];
};
export type BundlesReq = {
  accounts_in_bundle?: number;
  bundle_ids?: number[];
};

export const getProducts = (
  params?: ProductQueries
): Promise<AxiosResponse<ProductOffer[]>> => {
  return axios.get('/products/', {
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  });
};

export const getProductsAccountsOnboarding = (
  params?: ProductQueries
): Promise<AxiosResponse<TPackages[]>> => {
  return axios.get('/products/onboarding/accounts/', {
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  });
};

export const createProduct = (
  data: ProductData
): Promise<AxiosResponse<ProductData>> => {
  return axios.post('/products/', data);
};

export const saveProduct = (
  data: ProductData,
  id: number
): Promise<AxiosResponse<ProductData>> => {
  return axios.put(`/products/${id}/`, data);
};

export const saveStatus = (
  product_id: number
): Promise<AxiosResponse<ProductData>> => {
  return axios.put(`/products/${product_id}/status/`);
};

export const saveAddonsAssociations = (
  data: AddonsAssociationsReq
): Promise<AxiosResponse<ProductData>> => {
  return axios.post(`/products/addons/associations/`, data);
};

export const saveBundlesNumberInAccount = (
  data: BundlesReq
): Promise<AxiosResponse<ProductData>> => {
  return axios.patch(
    `/products/bundles/number-in-accounts/bulk-updates/`,
    data
  );
};

export const saveDisabledAddons = (
  addonIds: number[]
): Promise<AxiosResponse<ProductData>> => {
  return axios.patch(`/products/addons/status/`, { addon_ids: addonIds });
};

export const saveProductAddon = (
  product_id: number,
  data: ProductAddonsReq
): Promise<AxiosResponse<ProductData>> => {
  return axios.put(`/products/${product_id}/addons/`, data);
};

export const saveProductReset = (
  product_id: number,
  data: ProductResetReq
): Promise<AxiosResponse<ProductData>> => {
  return axios.put(`/products/${product_id}/resets/`, data);
};

export const saveProductMarketData = (
  product_id: number,
  data: ProductMarketDataReq
): Promise<AxiosResponse<ProductData>> => {
  return axios.put(`/products/${product_id}/market_data/`, data);
};

export const getProductOptions = (
  params?: ProductQueries
): Promise<AxiosResponse<ProductOption[]>> => {
  return axios.get('/products/options/', {
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  });
};

export const getProductDetail = (
  id: number
): Promise<AxiosResponse<ProductOffer>> => {
  return axios.get(`/products/${id}`);
};

export const uploadFile = (
  data?: FormData
): Promise<AxiosResponse<ProductFile>> => {
  return axios.post(`/files/`, data);
};

export const fetchAddOnsData = (
  platform?: string
): Promise<AxiosResponse<ProductOffer[]>> => {
  return axios.get('/products/onboarding/addons/', {
    params: { platform },
  });
};
